import VxeTableColgroupComponent from '../table/src/group';
import { dynamicApp } from '../dynamics';
export var VxeColgroup = Object.assign(VxeTableColgroupComponent, {
    install: function (app) {
        app.component(VxeTableColgroupComponent.name, VxeTableColgroupComponent);
        // 兼容旧用法
        app.component('VxeTableColgroup', VxeTableColgroupComponent);
    }
});
export var Colgroup = VxeColgroup;
dynamicApp.component(VxeTableColgroupComponent.name, VxeTableColgroupComponent);
// 兼容旧用法
dynamicApp.component('VxeTableColgroup', VxeTableColgroupComponent);
export default VxeColgroup;
